import moment from "moment";

import LocationModal from "./LocationModal";
import { useState } from "react";

export default function LoginHistoryCard({ item }) {
  const userType = Number(localStorage.getItem("user_type") || 7);
  // Safely extract fields with fallback values
  const {
    ip = "NO IP",
    deviceid = "NO DEVICE ID",
    device = "NO DEVICE",
    login_date,
    logout_date,
    date_created,
    location,
    longitude,
    city,
    country,
  } = item;

  const [open, setOpen] = useState(false);

  // Reusable date formatter
  const formatDate = (d) => (d ? moment(d).format("DD-MM-YYYY HH:mm:ss") : "-");

  return (
    <>
      <div className="menuContainer addHight text">
        <div onClick={() => userType === 1 ? setOpen(!open) : null} className="menuExchange large">
          {ip}
        </div>

        <div className="menuSymbol small">{deviceid}</div>

        <div className="menuSymbol large">{device}</div>

        <div className="menuLtt large">{formatDate(login_date)}</div>

        <div className="menuLtt large">{formatDate(logout_date)}</div>

        <div className="menuLtt large">{formatDate(date_created)}</div>
      </div>
      <LocationModal
        open={open}
        onClose={() => setOpen(false)}
        location={location}
        longitude={longitude}
        city={city}
        country={country}
      />
    </>
  );
}
